import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleComplete = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 10,
			fill: "#0B713A"
		}), /* @__PURE__ */ _jsx("path", {
			stroke: "#FFF",
			strokeWidth: 2,
			d: "m5.385 10.071 3.099 3.132 5.195-5.281.706-.719"
		})]
	})
});
export default SvgCircleComplete;
